import React, { FC } from 'react';
import { useNavigate } from 'react-router-dom';

import { Layout } from '@.layout';
import { Button } from '@.ui';
import { Auth, LinkHelper } from '@/Services';
import { UserRoleEnum } from '@/Types/api/User';

import S from './ProductProposals.module.scss';
import { ProductProposalsTable } from './ProductProposalsTable';

export const ProductProposals: FC = () => {
    const navigator = useNavigate();
    const auth = Auth.Use();

    return (
        <Layout name="ProductProposals">
            <h1 className={S.PageTitle}>
                Product Proposals
                <div>
                    {auth?.user?.role?.key === UserRoleEnum.PRODUCT_MANAGER && (
                        <Button color="brown" text="Import XLS" onClick={() => navigator(LinkHelper.productProposalsImportXls)} />
                    )}
                    <Button color="brown" text="Create product" onClick={() => navigator(LinkHelper.productProposalsCreate)} />
                </div>
            </h1>
            <ProductProposalsTable />
        </Layout>
    );
};
